import { render, staticRenderFns } from "./ScoresScythe.vue?vue&type=template&id=ace95bb4"
import script from "./ScoresScythe.vue?vue&type=script&lang=ts"
export * from "./ScoresScythe.vue?vue&type=script&lang=ts"
import style0 from "./ScoresScythe.vue?vue&type=style&index=0&id=ace95bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports